export const LS_EXPIRE_HOURS = 12;
